import React, { Component } from 'react';
import classnames from 'classnames';
import { Col } from 'react-bootstrap';

class ListItemView extends Component {

    handleClick(key) {
        this.props.selectItem(key);
    }

    render() {
        const { isSelected, item } = this.props;
        const { displayName, key } = item;
        const cx = classnames;
        const itemOptionCls = cx('input-text-option', { 'selected color-1': isSelected });

        return (
            <li className={ itemOptionCls } key={ key }
                onClick={ this.handleClick.bind(this, key) }>
                <Col className={ `form-group${(key === 'leads') ? ' with-star' : ''}` } xs={ 12 }>
                    { (key === 'leads') && <i className='fa icon-community_star' /> }
                    <button className='no-style-link-button'>{ displayName }</button>
                </Col>
            </li>
        );
    }
}

export default ListItemView;
